import { isMobile } from "react-device-detect";
import { MapProps } from "./components/Map/Map.interface";

export const birthday10LandingUrl = "/10years";
export const mapSize: MapProps["size"] = isMobile ? [3392, 2840] : [6785, 5680];
export const verticalPinCorrection = isMobile ? 170 : 340;
export const rulesLink = "/10_years/rules.pdf";
